var homeCarouselSlider = jQuery('.home-carousel-slider');
var youtubeModal = jQuery('.c-hero__youtube');
var youtubeModalIframe = jQuery('.c-hero__youtube__iframe');
var timer;
var videoTimeout = 30000;
var slideTimeout = 5000;

homeCarouselSlider.owlCarousel({
	loop: true,
	margin: 10,
	items: 1,
	singleItem: true,
	slideSpeed: 500,
	pagination: false,
	mouseDrag: false,
	touchDrag: false,
	autoplay: false,
	pullDrag: false,
	freeDrag: false,
	navigation: false,
	afterAction: slideChange,
});


function slideChange() {
	jQuery('.home-carousel-slider__nav .li:eq(' + this.currentItem + ') a').parent().addClass('active').siblings().removeClass('active');
	window.clearTimeout(timer);
	if (jQuery('#c-hero-' + this.currentItem + ' .c-hero__videopreview').length) {
		window.clearTimeout(timer);
		var video = jQuery('#c-hero-' + this.currentItem + ' .c-hero__videopreview')[0];
		video.currentTime = 0;
		video.play();
		timer = window.setTimeout(function() {
			changeSlide();
			video.pause();
		}, videoTimeout);
	} else {
		timer = window.setTimeout(function() {
			changeSlide();
		}, slideTimeout);
	}
}

function changeSlide() {
	window.clearTimeout(timer);
	homeCarouselSlider.trigger('owl.next');
}

window.changeSlide = changeSlide;

jQuery('.home-carousel-slider__nav .li').each(function() {
	var indx = jQuery(this).index();
	jQuery('a', this).on('click', function() {
		window.clearTimeout(timer);
		document.querySelectorAll('.c-hero__videopreview').forEach(vid => vid.pause());
		jQuery(this).parent().addClass('active').siblings().removeClass('active');
		homeCarouselSlider.trigger('owl.goTo', indx);
	});
});

jQuery('.c-hero__youtube__close').on('click', function() {
	youtubeModal.fadeOut();
	youtubeModalIframe.attr('src', '');
});

jQuery('.u-link--youtube').on('click', function() {
	window.clearTimeout(timer);
	youtubeModalIframe.attr('src', '');
	youtubeModalIframe.attr('src', jQuery(this).data('video-url'));
	youtubeModal.fadeIn();
});
